/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterAttributDto } from '../../models/mitarbeiter-attribut-dto';

export interface GetAllMitarbeiterAttribute$Plain$Params {
}

export function getAllMitarbeiterAttribute$Plain(http: HttpClient, rootUrl: string, params?: GetAllMitarbeiterAttribute$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MitarbeiterAttributDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllMitarbeiterAttribute$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MitarbeiterAttributDto>>;
    })
  );
}

getAllMitarbeiterAttribute$Plain.PATH = '/v1/mitarbeiter-attribute';
